export default "__VITE_ASSET__88070ddd__"